import { Button } from "@/components/ui/button";

export default function PageHeader({ icon: Icon, title, description, actions }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6">
      <div className="min-w-0">
        <div className="flex items-center gap-3">
          {Icon && (
            <div className="h-10 w-10 rounded-lg bg-secondary flex items-center justify-center shrink-0">
              <Icon className="h-5 w-5 text-primary" strokeWidth={2} />
            </div>
          )}
          <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 truncate">
            {title}
          </h1>
        </div>
        {description && (
          <p className="mt-3 text-slate-600 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
